import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const COUPLE_PROFILE_TO_WEDDING = {
  basic: 'couple-information',
  cultural: 'cultural',
  personal: 'personal',
  extras: 'extras',
  'basic-information': 'couple-information',
  'cultural-religious': 'cultural',
  'personal-touches': 'personal',
  'optional-extras': 'extras'
};

function CoupleProfileEditor() {
  const { sectionId } = useParams();
  const weddingSection = COUPLE_PROFILE_TO_WEDDING[sectionId] || 'couple-information';
  return <Navigate to={`/wedding-details?section=${weddingSection}`} replace />;
}

export default CoupleProfileEditor;
